import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Link } from '@alfa-bank/site-link';
import { Grid } from '@alfa-bank/site-grid-universal';
import { BlockMobile as Block } from '@alfa-bank/site-block/mobile';
import { LogoMobile as Logo } from '@alfa-bank/site-invest-emitents-common/components/logo-mobile';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';

import { ProfitabilityCellMobile as ProfitabilityCell } from '../cells/profitability/mobile';

import { AssetCard as Component } from './component';
import type { IDepsMobile, TAssetCardMobile } from './models';
import styles from './styles.css';

export const AssetCardMobile = createWidget<IDepsMobile, TAssetCardMobile>({
    Grid,
    Link,
    Block,
    Logo,
    ProfitabilityCell,
    Text,
    styles,
})(Component);
